<div class="modal" [ngClass]="{'md': smallModal == 'true', 'lg': bigModal =='true'}">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
<div class="modal-background"></div>
